import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const provideTranslateCore = () => [
  importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http, '/i18n/');
        },
        deps: [HttpClient],
      },
    }),
  ),
  {
    provide: APP_INITIALIZER,
    useFactory: (translate: TranslateService) => {
      return () => {
        const languageStored = localStorage.getItem('language');
        if (languageStored) {
          return translate.use(languageStored);
        } else if (navigator.language === 'fr' || navigator.language === 'en') {
          translate.setDefaultLang(navigator.language);
          return translate.use(navigator.language).toPromise();
        } else {
          translate.setDefaultLang('fr');
          return translate.use('fr').toPromise();
        }
      };
    },
    deps: [TranslateService],
    multi: true,
  },
];
